<template>
     <form @submit.prevent="handleSubmit($event)">
        <TabsPanelComponent 
            v-model="currentTab"
            :tabs="tabs"
            horizontal
            hiddenControls
        >
            <template #user>
                <div class="form-row mt-1">
                    <div class="form-group">
                        <input
                            v-model="form.name"
                            name="name"
                            type="text"
                            :class="['custom-input-transparent', {'is-invalid': formErrors.includes('name')}]"
                            placeholder="Nombre (s)"
                            @focus="trackFormFieldFocus('register_input-name')"
                        >
                    </div>
                </div>
                <div class="form-row mt-1">
                    <div class="form-group">
                        <input
                            v-model="form.last_name"
                            name="last_name"
                            type="text"
                            :class="['custom-input-transparent']"
                            placeholder="Apellidos"
                            @focus="trackFormFieldFocus('register_input-last_name')"
                        >
                    </div>
                </div>
                <div class="form-row mt-1">
                    <div class="form-group">
                        <input
                            v-model="form.email"
                            name="email"
                            type="text"
                            :class="['custom-input-transparent', {'is-invalid': formErrors.includes('email')}]"
                            placeholder="Email"
                            @focus="trackFormFieldFocus('register_input-email')"
                            readonly
                        >
                    </div>
                </div>

                <div class="form-row mt-1">
                    <div class="form-group">
                        <PhoneInput
                            v-model:phone="form.phone_number"
                            v-model:dialCode="form.dial_code"
                            :isInvalid="formErrors.includes('phone_number')"
                            @focus="trackFormFieldFocus('register_input-phone_number')"
                        ></PhoneInput>
                    </div>
                </div>
    
                <div class="form-row mt-1">
                    <div class="form-group">
                        <input
                            v-model="formattedInputRFC"
                            name="rfc"
                            :class="['custom-input-transparent']"
                            placeholder="RFC"
                            @focus="trackFormFieldFocus('register_input-rfc')"
                        >
                    </div>
                </div>
            </template>

            <template #address>
                <div class="form-row mt-1">
                    <div class="form-group">
                        <input
                            v-model="form.address.line_1"
                            name="address[line_1]"
                            type="text"
                            :class="['custom-input-transparent', {'is-invalid': formErrors.includes('line_1')}]"
                            placeholder="Dirección"
                            @focus="trackFormFieldFocus('register_input-address[line_1]')"
                        >
                    </div>
                </div>
    
                <div class="form-row mt-1">
                    <div class="form-group">
                        <input
                            v-model="form.address.line_2"
                            name="address[line_2]"
                            type="text"
                            :class="['custom-input-transparent', {'is-invalid': formErrors.includes('line_2')}]"
                            placeholder="Colonia"
                            @focus="trackFormFieldFocus('register_input-address[line_2]')"
                        >
                    </div>
                    <div class="form-group">
                        <input
                            v-model="form.address.postal_code"
                            maxlength="5"
                            name="address[postal_code]"
                            type="text"
                            :class="['custom-input-transparent', {'is-invalid': formErrors.includes('postal_code')}]"
                            placeholder="Código postal"
                            pattern="\d*"
                            oninput="this.value = this.value.replace(/\D/g, '')"
                            @focus="trackFormFieldFocus('register_input-address[postal_code]')"
                        >
                    </div>
                </div>
                <div class="form-row mt-1">
                    <div class="form-group">
                        <input
                            v-model="form.address.state"
                            name="address[state]"
                            type="text"
                            :class="['custom-input-transparent', {'is-invalid': formErrors.includes('state')}]"
                            placeholder="Estado"
                            @focus="trackFormFieldFocus('register_input-address[state]')"
                        >
                    </div>

                    <div class="form-group">
                        <input
                            v-model="form.address.city"
                            name="address[city]"
                            type="text"
                            :class="['custom-input-transparent', {'is-invalid': formErrors.includes('city')}]"
                            placeholder="Ciudad"
                            @focus="trackFormFieldFocus('register_input-address[city]')"
                        >
                    </div>
                </div>
                <div class="form-row my-1">
                    <div class="form-group">
                        <CountryReadOnly></CountryReadOnly>
                    </div>
                </div>

                <div class="form-row mt-1">
                    <div class="form-group">
                        <input
                            name="address[line_3]"
                            type="text"
                            class="custom-input-transparent"
                            placeholder="Referencia de domicilio (opcional)"
                            v-model="form.address.line_3"
                            @focus="trackFormFieldFocus('register_input-address[line_3]')"
                        >
                    </div>
                </div>
                <div class="w-100 my-1">
                    <input
                        v-model="form.chboxAgree"
                        id="chbox-agree"
                        name="chboxAgree"
                        type="checkbox"
                        class="custom-checkbox"
                        value="on"
                            @focus="trackFormFieldFocus('register_input-chbox_agree')"
                    >
                    <label for="chbox-agree" class="font-semibold font-sm ml-1">Estoy de acuerdo con el documento de </label><label @click.prevent="showFordibbenItems()" class="font-semibold font-sm cursor-pointer text-underline">articulos prohibidos</label>
                </div>
            </template>
        </TabsPanelComponent>

        <ul class="font-sm danger-color my-1 ml-1" v-if="error">
            <li v-for="error in error.errors"> {{error}}</li>
        </ul>

        <TransitionLabel
            labelClass="error-label w-100 mt-1"
            :show="validation.show"
        >
            {{validation.message}}
        </TransitionLabel>

        <div class="w-100 mt-1 text-right">
            <button type="button" @click="handleSubmit" class="btn-primary">Continuar</button>
        </div>
    </form>
    
    <ModalComponent
        v-model="modalImageFordibbenItems"
        width="80vh"
    >
        <img
            v-if="srsFordibbenItems && srsFordibbenItems!== ''"
            :src="srsFordibbenItems"
            style="width: 100%;"
        >
    </ModalComponent>
</template>

<script>
import { useGoogleAnalytics } from '../../composables/useGoogleAnalytics';
import { useSwalFire } from '../../composables/useSwalFire';
import CountryReadOnly from '../../global-components/CountryReadOnly.vue';
import InputPasswordGen from '../../global-components/InputPasswordGen.vue';
import ModalComponent from '../../global-components/ModalComponent.vue';
import PasswordStrength from '../../global-components/PasswordStrength.vue';
import PhoneInput from '../../global-components/PhoneInput.vue';
import TabsPanelComponent from '../../global-components/TabsPanelComponent.vue';
import TransitionLabel from '../../global-components/TransitionLabel.vue';
import apiClient from '../../services/apiClient';
import ProductsToImport from './forms/ProductsToImport.vue';

export default {
    components: {
        TransitionLabel,
        PasswordStrength,
        ModalComponent,
        PhoneInput,
        ProductsToImport,
        InputPasswordGen,
        TabsPanelComponent,
        CountryReadOnly
    },
    name: 'signup-form',
    props: {
        user: String,
        srsFordibbenItems: {
            type: String,
            default: ''
        },
        companyName: String,
        googleId: String
    },
    setup() {
        const {trackPageView, trackFormFieldFocus, trackFormSubmission} = useGoogleAnalytics()
        return {trackPageView, trackFormFieldFocus, trackFormSubmission}
    },
    data() {
        return {
            error: '',
            validation: {
                show: false,
                message: ''
            },
            tabs: [
                { name: "user", label: "Usuario"},
                { name: "address", label: "Dirección"},
            ],
            currentTab: 'user',
            passwordVisible: false,
            modalImageFordibbenItems: false,
            formErrors: [],
            passwordStrength: 0,
            form: {
                google_id: '',
                name: '',
                last_name: '',
                email: '',
                phone_number: null,
                rfc: '',
                address: {
                    line_1: '',
                    line_2: '',
                    postal_code: '',
                    state: '',
                    city: '',
                    line_3: ''
                },
                products_import: [''],
                chboxAgree: true,
                dial_code: '+52'
            },
            swalFire: null
        }
    },
    methods: {
        validateUserInfo () {
            if (!this.form.phone_number) this.formErrors.push('phone_number')
            if (!this.form.email) this.formErrors.push('email')
            if (!this.form.name) this.formErrors.push('name')

            const phoneRegex = /^\d{10}$/;
            if (!phoneRegex.test(this.form.phone_number)) this.setAlert('⚠️ Ingresa un número de teléfono válido de 10 dígitos.')

            return this.formErrors.length > 0 || this.validation.show
        },
        handleSubmit() {
            this.formErrors = [];
            this.validation.show = false
            this.validation.message= ''
            if (this.validateUserInfo()) return;

            if (this.currentTab === 'user') {
                this.currentTab = 'address'
                return;
            }

            // for(let field in this.form.address)
            //     if(!this.form.address[field]) this.formErrors.push(field);

            // if (!this.form.products_import.every(product => product && product.trim() !== '')) this.setAlert('⚠️ No se puede dejar ningun campo de productos vacio.')
            // this.form.products_import.forEach((val, index) => {
            //     if (!val || val.trim() === '') this.formErrors.push(`product-${index}`)
            // })

            // if(this.formErrors.length > 0 || this.validation.show) return;
            const address = this.form.address;
            let sendForm = this.form

            const isAddressEmpty = !address?.line_1 &&
                                !address?.line_2 &&
                                !address?.line_3 &&
                                !address?.postal_code &&
                                !address?.state &&
                                !address?.city;

            if (isAddressEmpty) {
                delete sendForm.address;
            }
            this.signup(sendForm);
        },
        async signup(formData) {
            this.trackFormSubmission('on_submit_complete_register')
            try {
                const response = await apiClient.post('/api/login/google/complete/registration', formData)
                console.log(response)
                if(response.data && response.data.access_token !== undefined)
                    this.notifySuccess(response)
                else
                    this.error = response;
            } catch (error) {
                this.setError(error)
            }
        },
        setAlert (message) {
            this.validation.message = message
            this.validation.show = true
        },
        setError (error) {
            console.log(error)
            const data = error.response.data
            if (data.message)
                this.validation.message = `⚠️ ${error.response.data.message}`

            if (data && data.errors && data.errors.email) {
                this.validation.message = `⚠️ ${data.errors.email[0]}`
                this.formErrors.push('email')
            }

            if (data && data.errors && data.errors['address.city']) this.setAlert('El campo de colonia es requerido.','city');
            if (data && data.errors && data.errors['address.postal_code']) this.setAlert('El codigo postal es requerido.','postal_code');
            if (data && data.errors && data.errors['address.state']) this.setAlert('El estado es requerido.','state');
            if (data && data.errors && data.errors['address.line_2']) this.setAlert('La colonia es requerida.','line_2');
            if (data && data.errors && data.errors['address.line_1']) this.setAlert('La dirección es requerida.','line_1');

            this.validation.show = true
        },
        setAlert (message, push) {
            this.validation.message = `⚠️ ${message}`
            this.formErrors.push(push)
        },
        notifySuccess (response) {
            const swalNotify = useSwalFire()
            swalNotify.onSuccessNotify({title: 'Informacion completa!', label: 'Tu registro se completo correctamente.'})
            .then(() => {
                localStorage.setItem('access_token', response.data.access_token);
                sessionStorage.setItem('ui', JSON.stringify({clientModal: true}))
                location.href = '/order/view';
            });
        },
        showFordibbenItems () {
            this.modalImageFordibbenItems = true
        },
        setName(name) {
            const palabras = name.trim().split(/\s+/);

            if (palabras.length > 2) {
                const apellidos = palabras.slice(-2).join(' ');
                const nombres = palabras.slice(0, -2).join(' ');
                this.form.name = nombres;
                this.form.last_name = apellidos;
            } else if (palabras.length === 2) {
                this.form.name = palabras[0];
                this.form.last_name = palabras[1];
            } else if (palabras.length === 1) {
                this.form.name = palabras[0];
                this.form.last_name = '';
            } else {
                this.form.name = '';
                this.form.last_name = '';
            }
        }
    },
    mounted () {
        this.swalFire = useSwalFire()
        const userFormat = JSON.parse(this.user)

        if (!userFormat) {
            useSwalFire().onErrorNotify({label: 'No se encontro el usuario', title: 'Error'})
            .then(() => {
                window.location.href = '/'
            })
        }

        this.form.email = userFormat.email;
        this.form.google_id = userFormat.google_id;
        this.setName(userFormat.name);
    },
    computed: {
        formattedInputRFC: {
            get() {
                return this.form.rfc;
            },
            set(value) {
                this.form.rfc = value.toUpperCase().replace(/\s/g, '');
            }
        }
    },
}
</script>